const InputWrapper = ({ children }) => (
  <div className="form-control">{children}</div>
);

export default InputWrapper;
